import { IGetState } from '../../../../../../../types/types';
import {
    SegmentCardBooleanValue,
    SegmentCardColorTagClickAddSourceValue,
    SegmentCardOptions
} from '../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { segmentTrackAction } from '../../../../../../../middlewares/segment';
import {
    ISegmentEventOption,
    TSegmentTrackPayload
} from '../../../../../../../middlewares/segment/trackEntities/types';

export const trackChangeColorTags = (
    track: TSegmentTrackPayload,
    source: SegmentCardColorTagClickAddSourceValue,
    count: number,
    isUnused?: boolean,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const extraOptions: ISegmentEventOption[] = [{
            name: SegmentCardOptions.COUNT,
            value: count
        }];
        if (isUnused) {
            extraOptions.push({
                name: SegmentCardOptions.UNUSED,
                value: SegmentCardBooleanValue.TRUE,
            });
        }
        dispatch(segmentTrackAction(track, {
            name: SegmentCardOptions.SOURCE,
            value: source
        }, extraOptions));
    };
    return action;
};
